/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_CopyInputs */

const en_image_inspector_copy = /** @type {(inputs: Image_Inspector_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy`)
};

const ar_image_inspector_copy = /** @type {(inputs: Image_Inspector_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نسخ`)
};

const bn_image_inspector_copy = /** @type {(inputs: Image_Inspector_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কপি`)
};

const de_image_inspector_copy = /** @type {(inputs: Image_Inspector_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopieren`)
};

const es_image_inspector_copy = /** @type {(inputs: Image_Inspector_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar`)
};

const fr_image_inspector_copy = /** @type {(inputs: Image_Inspector_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier`)
};

const pt_image_inspector_copy = /** @type {(inputs: Image_Inspector_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar`)
};

const zh_image_inspector_copy = /** @type {(inputs: Image_Inspector_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制`)
};

const tr_image_inspector_copy = /** @type {(inputs: Image_Inspector_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopyala`)
};

const ru_image_inspector_copy = /** @type {(inputs: Image_Inspector_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Копировать`)
};

const pl_image_inspector_copy = /** @type {(inputs: Image_Inspector_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiuj`)
};

/**
* | output |
* | --- |
* | "Copy" |
*
* @param {Image_Inspector_CopyInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_copy = /** @type {((inputs?: Image_Inspector_CopyInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_CopyInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_copy(inputs)
	if (locale === "bn") return bn_image_inspector_copy(inputs)
	if (locale === "de") return de_image_inspector_copy(inputs)
	if (locale === "es") return es_image_inspector_copy(inputs)
	if (locale === "fr") return fr_image_inspector_copy(inputs)
	if (locale === "pt") return pt_image_inspector_copy(inputs)
	if (locale === "zh") return zh_image_inspector_copy(inputs)
	if (locale === "tr") return tr_image_inspector_copy(inputs)
	if (locale === "ru") return ru_image_inspector_copy(inputs)
	if (locale === "pl") return pl_image_inspector_copy(inputs)
	return en_image_inspector_copy(inputs)
});